import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ActivityModule } from '../activity/activity.module';
import { NotificationListComponent } from '../notification/notification-list/notification-list';
import { NotificationDetailsComponent } from '../notification/notification-details/notification-details';
import { CustomNotificationDetails } from '../custom-notification/custom-notification-details';
import { GoAppMetricsComponent } from '../go-app-metrics/go-app-metrics.component';
import { GoAppCustomersPaneComponent } from '../go-app-customers-pane/go-app-customers-pane.component';

import { GoAppTitleComponent } from '../go-app-title/go-app-title.component';
import { GoAppNavigationMenuComponent } from '../go-app-navigation-menu/go-app-navigation-menu.component';
import { GoAppFooterNavigationMenuComponent } from '../go-app-footer-navigation-menu/go-app-footer-navigation-menu.component';
import { GoAppActivitiesComponent } from '../go-app-activities/go-app-activities';
import { GoAppActivityDetailsComponent } from '../go-app-activity-details/go-app-activity-details.component';
import { GoAppCalendarComponent } from '../go-app-calendar/go-app-calendar';
import { GoAppTodoComponent } from '../go-app-todo/go-app-todo';
import { GoAppActivitiesPageComponent } from '../../pages/go-app-activities-page/go-app-activities-page.component';
import { GoAppNotificationPageComponent } from '../../pages/go-app-notification-page/go-app-notification-page';
import { ProfilePopupComponent } from '../popover/profile-popup/profile-popup.component';
import { UserStatusPopoverComponent } from '../popover/user-status-popover/user-status-popover.component';

const GO_APP_DECLARATIONS = [
  GoAppTitleComponent,
  GoAppNavigationMenuComponent,
  GoAppFooterNavigationMenuComponent,
  GoAppActivitiesComponent,
  GoAppActivityDetailsComponent,
  GoAppCalendarComponent,
  GoAppTodoComponent,
  GoAppActivitiesPageComponent,
  GoAppNotificationPageComponent,
  ProfilePopupComponent,
  UserStatusPopoverComponent,
];

@NgModule({
  imports: [
    SharedModule,
    ActivityModule,
    NotificationListComponent,
    NotificationDetailsComponent,
    CustomNotificationDetails,
    GoAppMetricsComponent,
    GoAppCustomersPaneComponent,
  ],
  declarations: GO_APP_DECLARATIONS,
  exports: GO_APP_DECLARATIONS,
})
export class GoAppModule {}
